// extracted by mini-css-extract-plugin
var _1 = "ToolbarHighlightButton-module__active--w1_tr";
var _2 = "ToolbarHighlightButton-module__animateUploadProgressBarWidth--or9q0";
var _3 = "ToolbarHighlightButton-module__animatedBackground--MHHue";
var _4 = "ToolbarHighlightButton-module__blue--DrqSD";
var _5 = "ToolbarHighlightButton-module__green--v4JjR";
var _6 = "ToolbarHighlightButton-module__highlightIcon--CBvyp";
var _7 = "ToolbarHighlightButton-module__highlightMenu--BakAn";
var _8 = "ToolbarHighlightButton-module__red--tb4kF";
var _9 = "ToolbarHighlightButton-module__yellow--RnqeI";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "blue", _5 as "green", _6 as "highlightIcon", _7 as "highlightMenu", _8 as "red", _9 as "yellow" }
